import { BankingInfoResponse } from '@/types/bankingInfo';
import { Box, Card, Typography } from '@mui/material';
import { AccountBalance } from '@mui/icons-material';
import BankOfAmericaIcon from '@/components/icons/BankOfAmericaIcon';
import ChaseIcon from '@/components/icons/ChaseIcon';
import CitiIcon from '@/components/icons/CitiIcon';
import UsBankIcon from '@/components/icons/UsBankIcon';
import WellsFargoIcon from '@/components/icons/WellsFargoIcon';

type AdvisorDashboardBankRatesProps = {
  bankingInfo: BankingInfoResponse;
};

export default function AdvisorDashboardBankRates({
  bankingInfo,
}: AdvisorDashboardBankRatesProps) {
  const { topBanksRates } = bankingInfo.referenceInterestRates;

  function BankIcon({ name }: { name: string }) {
    if (name === 'JP Morgan Chase') {
      return <ChaseIcon />;
    } else if (name === 'Citigroup') {
      return <CitiIcon />;
    } else if (name === 'Bank of America') {
      return <BankOfAmericaIcon />;
    } else if (name === 'US Bank') {
      return <UsBankIcon />;
    } else if (name === 'Wells Fargo') {
      return <WellsFargoIcon />;
    }

    return <AccountBalance color="primary" />;
  }

  return (
    <Card>
      <Typography variant="h5" mb={1}>
        Top 5 Bank Savings Rates (APY)
      </Typography>
      {topBanksRates.map(bank => {
        const { name, rate } = bank;
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              borderBottom: '1px solid lightgrey',
              mb: 1,
              pb: 1,
              pt: 1,
              '&:last-child': { border: 0, pb: 0 },
            }}
            key={name}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 2,
              }}>
              <BankIcon name={name} />
              <Typography>{name}</Typography>
            </Box>
            <Typography fontWeight="bold">{rate}%</Typography>
          </Box>
        );
      })}
    </Card>
  );
}
